<dspx-base-form [formServiceEndpoint]="formServiceEndpoint"
                [templateId]="applicationAndTemplateId"
                [versionNo]="versionNo"
                formName="Form Response"
                [entityId]="id"
                (onFormLoad)="formLoaded($event)"
                (onDialogSubmit)="handleDialogButtonClick($event, activeDialog)"
                (onActionButtonClick)="actionButtonClicked($event)"
                (onSave)="save($event)"
                (onCancel)="cancel($event)"                       
                (onModelChange)="modelChanged($event)">
</dspx-base-form>
